<script setup>
import DSButton from 'primevue/button';
import { DISCLAIMERS } from '@/data/capacity';
import RollingCapacityAnimationModal from '@/components/modals/RollingCapacityAnimationModal.vue';
import SplitModal from '@/components/modals/SplitModal.vue';
import purpleCoinsImage from '@/assets/images/purple-coins-zoomed.png';

const props = defineProps({
  visible: Boolean,
});

const emit = defineEmits(['submitModal', 'hide']);

const openLink = (url) => {
  window.open(url, '_blank');
};
</script>

<template>
  <SplitModal
    :visible="props.visible"
    title="Meet your Rolling Funding Capacity"
    @hide="emit('hide')"
  >
    <template #content
      ><div :class="$style.content">
        <div :class="$style.content__section">
          <p :class="$style.content__section__copy">
            Congratulations, your Rolling Funding Capacity is ready. This
            facility is designed for businesses like yours to ensure ongoing
            liquidity and cash flow stability. Use it as your strategic,
            always-on source of capital to fuel sustained growth.
          </p>
        </div>

        <div :class="$style.content__section">
          <h3 :class="$style.content__section__title">How it Works</h3>
          <RollingCapacityAnimationModal />
        </div>

        <div :class="$style.content__section">
          <h3 :class="$style.content__section__title">
            Ready to Use Your Capital?
          </h3>
          <p :class="$style.content__section__copy">
            Click Get started to access your approved capacity through a Cash
            Advance or Invoice Funding and put your capital to work.
          </p>
        </div>
      </div></template
    >

    <template #footer>
      <div :class="$style.controls">
        <DSButton
          :class="$style.controls__item"
          class="p-button-secondary p-button-outlined"
          label="Learn More"
          @click="openLink(DISCLAIMERS.UNDERSTANDING_ROLLING_CAPACITY_LINK)"
        />
        <DSButton
          :class="$style.controls__item"
          label="Get Started"
          @click="emit('submitModal')"
        />
      </div>
    </template>

    <template #image>
      <img :src="purpleCoinsImage" alt="Purple coins" />
    </template>
  </SplitModal>
</template>

<style lang="less" module>
.content__section {
  margin-bottom: 40px;
}

.content {
  height: 575px;
}

body h3.content__section__title {
  margin: 0 0 8px 0;
  font-size: 17px;
  font-weight: 600;
  line-height: 28px;
  font-family: @regular-font;
  color: #000;
  margin-right: 40px;
}

.content__section__copy {
  margin: 0;
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  font-family: @regular-font;
  color: #000;
  margin-right: 40px;
}

.controls {
  display: flex;
  justify-content: space-between;
  column-gap: 12px;

  .controls__item.controls__item {
    width: 100%;
    margin: 0;
  }
}

@media (min-width: 900px) {
  .content {
    max-width: 600px;
  }
}
</style>
